import BackButton from "../../../../components/common/BackButton/BackButton"
import banner from "../../../../assets/images/UserPortal/banner.png"
import styles from "./FAQs.module.scss"
import YellowHeaderWrapper from "../../../../components/common/YellowHeaderWrapper/YellowHeaderWrapper"
import { AiOutlineLike, AiOutlineDislike } from "react-icons/ai";
import { BsChevronDown } from "react-icons/bs";
import classNames from "classnames";
import CustomerServiceModal from "./CustomerServiceModal/CustomerServiceModal";
import { useState } from "react";

const FAQs = () => {

  const [isModalOpen, setIsModalOpen] = useState(false)
  const toggle = () => setIsModalOpen(!isModalOpen)

  const data = [{ question: "How to place an order?", answer: "Answer here, with relevant images for visual guidelines" }]

  const realtedQuestions = [
    'What should I do if I receive a damaged item?',
    'Do you provide tracking information?',
    'Can I place an order over the phone?',
    'How are shipping costs calculated?'
  ]

  return (
    <section>
      <BackButton />
      <div className={styles["banner-container"]}>
        <img src={banner} alt="" className="w-100" />
        <div className={styles["content"]}>
          <div className={styles["banner-heading"]}>Frequently Asked Question (FAQ’s)</div>
          <div className={styles["para"]}>What issues are you facing?</div>
          <div className={styles["para"]}>We are here for solving our customers problems.</div>
        </div>
      </div>

      <div className="m-3">
        <div className="fs-md-4">
          We are here to help our customers. Please checkout from the following to sort out your problem or you can contact to our help center for further help.
        </div>

        <YellowHeaderWrapper title={"FAQ Categories"} bordered={false}>
          {data.map(({ question, answer }, index) => (
            <div key={index}>
              {question && (
                <div className={styles.wrapper}>
                  <div className={`${styles.label} ${styles.question}`}>Q</div>
                  <div>{question}</div>
                </div>
              )}
              {answer && (
                <div className={styles.wrapper}>
                  <div className={`${styles.label} ${styles.answer}`}>A</div>
                  <div>{answer}</div>
                </div>
              )}
            </div>
          ))}
        </YellowHeaderWrapper>

        <div className="text-center py-3 d-flex flex-column gap-2">
          <div>
          Was this answer helpful?
          </div>
          <div className={styles['likes-dislikes']}>
            <div className="d-flex align-items-center gap-2">
              <div>
              Yes
              </div>
              <div className="d-flex align-items-center"><AiOutlineLike /></div>
            </div>
            <div className="d-flex align-items-center gap-2">
              <div>No</div>
              <div className="d-flex align-items-center"><AiOutlineDislike /></div>
            </div>
          </div>

          <div>
            Have more questions? <label className={styles['text-orange']}>Customer Service</label>
          </div>
        </div>

        <YellowHeaderWrapper title={"Related Questions"} bordered={false}>
          <div className={styles["related-questions"]}>
            {realtedQuestions.map((item, index) => (
              <div key={index} className={classNames("p-3", styles["related-question"])}>
                <div>{item}</div>
                <div>
                  <BsChevronDown />
                </div>
              </div>
            ))}
          </div>
        </YellowHeaderWrapper>

        <div className="d-flex justify-content-center">
          <div className="py-3 px-5 shadow text-center my-3">
            <div className="fs-5 mb-2">Can’t find a question you are looking for?</div>
            <button className={styles["customer-service-button"]} onClick={toggle}>Customer Service</button>
          </div>
        </div>
      </div>

      <CustomerServiceModal isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />
    </section>
  )
}

export default FAQs
